import { utils } from '@digital-commerce/shared-utils'
import { bool, object } from 'prop-types'

import useTranslate from '../../../hooks/useTranslate'

import { buildContractTermLabel } from '../../../utils/display'
import {
  getChangeUrlFromMobilityOffer,
  getFinancedAccessoryPenalties,
  isPhone
} from '../../../utils/mobility'

import CartItem, { BasicInfo, ActionBar, OfferDetailsContainer } from '../../molecules/CartItem'
import FinancedAccessoryExistingBalanceMessage from '../../molecules/FinancedAccessory/FinancedAccessoryExistingBalanceMessage'
import ItemOutOfStock from '../../molecules/RealTimeInventory/ItemOutOfStock'
import OfferDetails from './OfferDetails'

import {
  calculateDueTodaySubTotal,
  getAttributes,
  getContractTermLabel,
  getSubHeading
} from './utils'

const { getMonthlyTotalPrice, isBusinessCart } = utils.cart

const MobilityAccessory = ({
  mobAccessory,
  isRemoveButtonHidden,
  cart,
  isPurchasedWithPhone,
  isFirstAccessoryInGroup,
  financedAccessoryGroup
}) => {
  const translate = useTranslate()

  const subHeadingCategory = getSubHeading(mobAccessory)
  const changeUrl = getChangeUrlFromMobilityOffer(mobAccessory)
  const dueTodaySubTotal = calculateDueTodaySubTotal(mobAccessory)
  const dueMonthlySubTotal = getMonthlyTotalPrice(mobAccessory)?.subTotal

  const attributes = getAttributes(mobAccessory, translate)

  const term = getContractTermLabel(
    mobAccessory,
    isPurchasedWithPhone,
    translate,
    buildContractTermLabel
  )

  const financedAccessoryPenalties = getFinancedAccessoryPenalties(financedAccessoryGroup)
  const financedAccessoryBalanceMessage =
    !isPhone(mobAccessory) && isFirstAccessoryInGroup ? (
      <FinancedAccessoryExistingBalanceMessage
        financedAccessoryPenalties={financedAccessoryPenalties}
      />
    ) : null

  const outOfStockNotification = (
    <ItemOutOfStock
      device={mobAccessory}
      category={subHeadingCategory}
      isBusinessCart={isBusinessCart(cart)}
    />
  )

  return (
    <CartItem cartItem={mobAccessory}>
      <BasicInfo
        subHeading={translate(`subHeading.${subHeadingCategory}`)}
        changeUrl={changeUrl}
        dueTodaySubTotal={dueTodaySubTotal}
        monthlySubTotal={dueMonthlySubTotal}
        attributesOverride={attributes}
        term={term}
        financedAccessoryBalanceMessage={financedAccessoryBalanceMessage}
        inventory={mobAccessory?.inventory}
        mobOutOfStockNotification={outOfStockNotification}
      />
      <ActionBar isShowDetailsCtaHidden={false} isRemoveButtonHidden={isRemoveButtonHidden} />
      <OfferDetailsContainer>
        <OfferDetails
          mobAccessory={mobAccessory}
          isFirstAccessoryInGroup={isFirstAccessoryInGroup}
          financedAccessoryGroup={financedAccessoryGroup}
        />
      </OfferDetailsContainer>
    </CartItem>
  )
}

export default MobilityAccessory

MobilityAccessory.propTypes = {
  mobAccessory: object.isRequired,
  isRemoveButtonHidden: bool,
  cart: object.isRequired,
  isPurchasedWithPhone: bool,
  isFirstAccessoryInGroup: bool,
  financedAccessoryGroup: object
}

MobilityAccessory.defaultProps = {
  isRemoveButtonHidden: false,
  isPurchasedWithPhone: false,
  isFirstAccessoryInGroup: false,
  financedAccessoryGroup: null
}
